import * as React from 'react';
export const useFirstRender = callback => {
  const isFirstRender = React.useRef(true);

  if (isFirstRender.current) {
    isFirstRender.current = false;
    callback();
  }
};


//////////////////
// WEBPACK FOOTER
// ../@mui/x-data-grid/hooks/utils/useFirstRender.js
// module id = 210
// module chunks = 25